/** The user's permitted values as a lowercase lookup set, or undefined when unrestricted. */
export var noteScopeOf = function (user) {
    if (!user)
        return undefined;
    if (user.permittedNoteTypes == null)
        return undefined;
    return new Set(user.permittedNoteTypes
        .map(function (value) { return value === null || value === void 0 ? void 0 : value.trim().toLowerCase(); })
        .filter(function (value) { return !!value; }));
};
export var isNoteVisible = function (note, scope) {
    var _a, _b;
    if (!scope)
        return true;
    var noteType = ((_a = note.noteType) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) || undefined;
    var name = ((_b = note.name) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase()) || undefined;
    if (!noteType && !name)
        return true;
    // Both fields are checked, and both must pass — a permitted value in one must not vouch for a
    // restricted value in the other.
    if (noteType && !scope.has(noteType))
        return false;
    if (name && !scope.has(name))
        return false;
    return true;
};
export var filterVisibleNotes = function (notes, scope) {
    if (!(notes === null || notes === void 0 ? void 0 : notes.length))
        return notes || [];
    if (!scope)
        return notes;
    return notes.filter(function (note) { return isNoteVisible(note, scope); });
};
